export default ({disabled = false,unitDisabled = true}) => [
  // {
  //   field: 'seq',
  //   width: 50,
  //   align: 'center',
  //   fixed: 'left',
  //   type: 'seq',
  // },
  {
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: !disabled,
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 50,
    slots: {
      default: 'opt',
    },
    visible: !disabled,
  },
  {
    field: 'seqNo',
    title: '序号',
    headerAlign: 'center',
    align: 'center',
    width: 50,
  },
  {
    field: 'minMatch',
    align: 'center',
    minWidth: 150,
    title: '(>)区间下限',
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 4,
        min: 0,
        step: 0.01,
        placeholder: '请输入(>)区间下限',
      },
    },
  },
  {
    field: 'maxMatch',
    align: 'center',
    minWidth: 150,
    title: '(<=)区间上限',
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 4,
        min: 0,
        step: 0.01,
        placeholder: '请输入(<=)区间上限',
      },
    },
  },
  {
    field: 'price',
    align: 'center',
    minWidth: 100,
    title: '费用',
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 4,
        min: 0,
        step: 0.01,
        placeholder: '请输入费用',
      },
    },
  },
  {
    field: 'unit',
    align: 'center',
    minWidth: 150,
    title: '单位',
    editRender: {
      name: 'ElSelect',
      options: [],
      props: {
        disabled: unitDisabled,
        size: 'mini',
        default: true,
        clearable: true,
        filterable: true,
      },
    },

  },
]
